import Dialog from "@mui/material/Dialog";
import {Button, IconButton} from "@mui/material";
import {useReducer, useState} from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {toast, ToastContainer} from "react-toastify";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {ComboBox} from "../../comboBox/ComboBox.jsx";
import {KeyAccountApprovalStatus} from "./utils.js";
import {updateSubscriptionStatus} from "./KeyAccountsApproval.handlers.js";
import {ApprovedByComboBox} from "./ApprovedByComboBox.jsx";

export function approvedByReducer (state, action) {
  return {...state, [action.id]: action.value};
}

export const SubscriptionStatusModal = ({isOpen, handleClose, subscriptions}) => {
    const [newStatus, setNewStatus] = useState(null)
    const [approvedByMap, approvedByMapDispatch] = useReducer(approvedByReducer, {})

    async function handleUpdateSubscription() {
        const subscriptionCalls = subscriptions.map(subscription => {
          updateSubscriptionStatus(subscription.subscriptionIds, newStatus, approvedByMap[subscription.id]);
        });
        await Promise.all(subscriptionCalls)
            .then(() => {toast.success("Update success!")})
            .catch(err => toast.error(err))
            .finally(() => handleClose());
    }

    const APPROVAL_STATUS = Object.keys(KeyAccountApprovalStatus).map(key => {
        return {
            "displayName": KeyAccountApprovalStatus[key],
            "value": key
        }
    })

    const statusAssignee = newStatus === 'DENIED' ? 'Denier' : 'Approver'

    return (
        <div>
            <Dialog
                open={isOpen}
                onClose={/* istanbul ignore next */() => {
                    handleClose()
                    setNewStatus(null)
                }}
                fullWidth={true}
            >
                <DialogTitle sx={{m: 0, p: 2}} id="customized-dialog-title">
                    Update Subscription Status
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={/* istanbul ignore next */() => {
                        handleClose()
                        setNewStatus(null)
                    }}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon/>
                </IconButton>
                <DialogContent style={{"paddingTop": 0}}>
                    <h2>This action will update {subscriptions.reduce((acc, item) => acc + item?.subscriptionIds?.length, 0)} subscription(s).</h2>
                    <ComboBox
                        testId="subscription-combobox"
                        style={{"paddingTop": 1}}
                        label="New Status"
                        data={APPROVAL_STATUS}
                        isMultiple={false}
                        disableCloseOnSelect={false}
                        onChange={(event, value) => {
                            setNewStatus(value.value)
                        }
                        }
                    />
                    {
                        (newStatus === "APPROVED" || newStatus === "DENIED") && <div>
                            {subscriptions.map(subscription => {
                              return <div key={subscription.id}>
                                <h2>{statusAssignee} for {subscription.retailerName}({subscription.categoryName})</h2>
                                <ApprovedByComboBox retailerSfid={subscription.retailerSfid} onChange={
                                  (_, value) => {approvedByMapDispatch({id: subscription.id, value: value.value})}
                                } statusAssignee={statusAssignee}/>
                              </div>
                            })}
                        </div>
                    }
                </DialogContent>
                <DialogActions style={{"paddingRight": "20px"}}>
                    <Button
                        variant="contained"
                        onClick={handleUpdateSubscription}
                    > Confirm </Button>
                    <Button
                        variant="contained"
                        onClick={/* istanbul ignore next */() => {
                            handleClose()
                            setNewStatus(null)
                        }}> Cancel </Button>
                </DialogActions>
            </Dialog>
            <ToastContainer/>
        </div>
    )
}


